import React, { type ReactNode } from 'react';
import { StaticIntlProvider } from '@cultureamp/i18n-react-intl';

type Props = {
  locale?: string;
  children: ReactNode;
};

declare const window: Window & { LOCALE: string };

// A wrapper for react-intl StaticIntlProvider that takes care of loading
// the right messages.json translation file for the current locale.
//
// Wrapping your application with this allows you to use
// <FormattedMessage> etc components.
//
// By default it expects Rails layouts/_head.html.haml to set a global LOCALE variable

/**
 * This function converts Murmur's verison of locales to the version that is used more widely in CultureAmp.
 * @param locale
 */
const reverseLocaleLoaderFilter = (locale: string) => {
  switch (locale) {
    case 'kr':
      return 'ko';
    case 'no':
      return 'nb';
    case 'en-360':
      return 'en';
    case 'en-gb':
      return 'en-GB';
    default:
      return locale;
  }
};

const I18nLoader: React.FC<Props> = ({ children, locale = window.LOCALE }) => {
  return (
    <StaticIntlProvider locale={reverseLocaleLoaderFilter(locale)}>
      {children}
    </StaticIntlProvider>
  );
};

export default I18nLoader;
